import { useEffect, useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: ${window.innerHeight}px;
  width: 100vw;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 111;
  opacity: ${(props) => (props.hiddenState === 1 ? '0' : '1')};
  ${(props) => (props.hiddenState === 2 ? 'display: none;' : '')}

  img {
    width: 300px;
  }

  transition: opacity 0.8s;
`;

let timer;
const Loading = ({ isLoading }) => {
  const [hiddenState, setHiddenState] = useState(0);

  useEffect(() => {
    if (isLoading) {
      clearInterval(timer);
      return setHiddenState(0);
    }

    setHiddenState(1);

    timer = setInterval(() => {
      setHiddenState(2);
    }, 800);
  }, [isLoading]);

  return (
    <Container hiddenState={hiddenState}>
      <img src={require('assets/branding/logo-black.png')} alt="" />
    </Container>
  );
};

export default Loading;
